var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInterested(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_3649_56071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.4083 7.01481L15.446 6.43905L13.674 2.84861C12.9896 1.46172 11.0105 1.46214 10.3263 2.84856L8.55426 6.439L4.59197 7.01481C3.06136 7.23719 2.45039 9.11945 3.55748 10.1987L6.42464 12.9935L5.74781 16.9397C5.48639 18.4641 7.08759 19.6268 8.4562 18.9075L12.0002 17.0442L15.5442 18.9075C16.9109 19.6259 18.514 18.4638 18.2526 16.9397L17.5758 12.9934L20.443 10.1987C21.5503 9.11903 20.9383 7.23714 19.4083 7.01481ZM19.326 9.05298L16.1577 12.1413C15.9691 12.3251 15.8831 12.5899 15.9276 12.8494L16.6755 17.2102C16.7131 17.4292 16.4852 17.5946 16.2886 17.4913L12.3724 15.4324C12.1394 15.31 11.8609 15.31 11.6279 15.4324L7.71159 17.4913C7.5149 17.5947 7.28714 17.4292 7.32469 17.2102L8.07262 12.8494C8.11711 12.5899 8.03109 12.3251 7.84256 12.1413L4.67423 9.05298C4.51509 8.89787 4.60214 8.63013 4.82203 8.59811L9.20053 7.96187C9.46106 7.924 9.68634 7.76041 9.80287 7.5243L11.761 3.55666C11.8593 3.35753 12.1409 3.35739 12.2392 3.5567L14.1974 7.5243C14.3139 7.76041 14.5392 7.92405 14.7997 7.96187L19.1782 8.59811C19.3981 8.63013 19.4851 8.89792 19.326 9.05298Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.31414 2.20915L5.35738 0.892292C5.0976 0.534917 4.59735 0.455604 4.23997 0.715386C3.88255 0.975073 3.80328 1.47537 4.06302 1.83279L5.01978 3.1496C5.27966 3.50717 5.77991 3.58615 6.13719 3.32651C6.49461 3.06687 6.57388 2.56657 6.31414 2.20915Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.14052 14.0101C3.00406 13.5899 2.55275 13.3598 2.13247 13.4965L0.552969 14.0097C0.132781 14.1462 -0.0971407 14.5975 0.0393593 15.0177C0.176094 15.4386 0.628156 15.6678 1.04741 15.5313L2.62691 15.0181C3.04714 14.8816 3.27706 14.4303 3.14052 14.0101Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.7583 0.715358C19.4009 0.455671 18.9006 0.534843 18.6409 0.892265L17.6841 2.20908C17.4244 2.5665 17.5036 3.06684 17.8611 3.32648C18.2186 3.58626 18.7189 3.50686 18.9785 3.14958L19.9352 1.83276C20.1949 1.47534 20.1157 0.974999 19.7583 0.715358Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.4472 14.0097L21.8677 13.4965C21.4476 13.3597 20.9962 13.5899 20.8597 14.0101C20.7231 14.4303 20.9531 14.8817 21.3733 15.0182L22.9528 15.5314C23.3721 15.6677 23.8241 15.4386 23.9608 15.0178C24.0974 14.5976 23.8674 14.1463 23.4472 14.0097Z",
    fill: "#222222"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.9992 20.2109C11.5574 20.2109 11.1992 20.5691 11.1992 21.0109V22.6346C11.1992 23.0764 11.5574 23.4345 11.9992 23.4345C12.441 23.4345 12.7992 23.0764 12.7992 22.6346V21.0109C12.7992 20.5691 12.441 20.2109 11.9992 20.2109Z",
    fill: "#222222"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3649_56071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterested);
export default __webpack_public_path__ + "static/media/interested.2d47026bfacaa37267ba289506b09c88.svg";
export { ForwardRef as ReactComponent };